import { pollJSONUntil } from "../framework/api";
import { getParam } from "../framework/query";

document.addEventListener("DOMContentLoaded", async function () {
  if (!document.querySelector(".bpf-refreshing-page")) {
    return;
  }

  const year = getParam("year", new Date().getFullYear());
  const url = p`/ajax/finance/bpf/is_available?year=${year}`;
  await pollJSONUntil(({ available }) => available, url);

  location.reload();
});
